'use strict';

var moment = require('moment');
var rome = require('./rome');

rome.use(moment);

module.exports = rome;



//////////////////
// WEBPACK FOOTER
// ./~/rome/src/rome.moment.js
// module id = 294
// module chunks = 0